import { LayoutRouter } from "@/layouts/LayoutRouter";
import { Typography } from "@/components/ui/typography";

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      "stripe-pricing-table": unknown;
    }
  }
}

export default function Page() {
  return (
    <>
      <LayoutRouter
        isHorizontalPaddingIncluded={false}
        isVerticalPaddingIncluded={false}
        isFooterVisible={true}
        isPublicLayout
        isRulersIncluded={true}
        topbarMaxWidth={"xl"}
      >
        <div className="w-full flex justify-center items-center h-full scheme-normal">
          <div>
            <Typography>Pricing</Typography>
          </div>
        </div>
      </LayoutRouter>
    </>
  );
}
